/**
 * テナントが管理する事業場
 * テナント => 収集運搬 or 処分業者 => 事業場
 * 搬入引取の検索条件で利用
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/tenants/trader_locations`

const search_tenant_trader_location = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index ({ commit }, { conditions = {} }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: conditions }).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 事業場詳細の取得
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_tenant_trader_location
